import { useContext } from 'react'
import { AuthContext } from '../context/AuthProvider'
import { UserContextType } from '../services/interfaces/auth'

const useAuth = (): UserContextType => {
  return useContext(AuthContext)
}

export default useAuth